<template>
    <div class="bottom_controller">
        <div class="selected_bar" v-if="(containerMaterial || selectedMaterial) && flowerHeightShow">
            <div v-if="containerMaterial" class="mb-10">
                <div>容器</div>
                <div>宽:{{ ((containerMaterial.radius * 2) / 28).toFixed(2) }}</div>
                <div>高:{{ (containerMaterial.height / 28).toFixed(2) }}</div>
            </div>
            <div v-if="selectedMaterial">
                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                    {{ selectedMaterial.name }}
                </div>
                <div>高:{{ (selectedMaterial.height / 28).toFixed(2) }}</div>
            </div>
        </div>
        <!-- <div class="design_bar lv_flex_center" @click="toDesign">
            做效果图
            </div> -->
        <template v-if="$store.state.routeParams.mode === 'edit'">
            <div class="top_left_group">
                <button type="button" class="top_guide_button" @click="startNoviceGuide">
                    <van-icon name="question-o" />
                    <span>新手指引</span>
                </button>
            </div>
            <div class="top_action_group">
                <button type="button" class="top_action_btn top_save_btn" @click="save()">
                    <van-icon name="passed" />
                    <span>保存</span>
                </button>
                <button type="button" class="top_action_btn top_score_btn" @click="scoreArtwork">
                    <van-icon name="chart-trending-o" />
                    <span>评估</span>
                </button>
            </div>
            <div
                v-if="$store.state.routeParams.type === 'practice'"
                ref="editorModeSwitch"
                class="editor_mode_switch"
                :class="{ dragging: !!modeSwitchDragState }"
                :style="modeSwitchStyle"
                @pointerdown="startModeSwitchDrag"
            >
                <button type="button" :class="{ active: editorType === 'free3d' }" @click="switchEditorType('free3d')">3D</button>
                <button type="button" :class="{ active: editorType === 'studio' }" @click="switchEditorType('studio')">棚景</button>
            </div>
            <div class="studio_toolbar" v-if="editorType === 'studio'" @click.stop>
                <div class="studio_toolbar_actions">
                    <button
                        type="button"
                        class="studio_tool_btn studio_preset_btn"
                        :class="{ active: !studioBackground }"
                        @click.stop="toggleStudioPresetMenu"
                    >
                        <span>{{ currentStudioPresetLabel }}</span>
                        <van-icon name="arrow-down" />
                    </button>
                    <button type="button" class="studio_tool_btn" :class="{ active: studioBackgroundSource === 'upload' }" @click="triggerStudioBackgroundUpload">上传</button>
                    <button type="button" class="studio_tool_btn" :class="{ active: studioLibraryVisible || studioBackgroundSource === 'library' }" @click="toggleStudioLibrary">
                        背景库
                    </button>
                    <button type="button" class="studio_tool_btn" :class="{ active: studioAdjustVisible }" @click="toggleStudioAdjust">调整</button>
                    <button v-if="studioBackground" type="button" class="studio_tool_btn studio_clear_btn" @click="clearStudioBackground">清除</button>
                </div>
                <div v-if="studioPresetMenuVisible" class="studio_preset_dropdown" @click.stop>
                    <button
                        v-for="item in studioPresets"
                        :key="item.value"
                        type="button"
                        :class="{ active: !studioBackground && studioPreset === item.value }"
                        @click="setStudioPreset(item.value)"
                    >
                        {{ item.label }}
                    </button>
                </div>
                <input ref="studioBackgroundInput" class="studio_upload_input" type="file" accept="image/*" @change="handleStudioBackgroundUpload" />
            </div>
            <div v-if="editorType === 'studio' && studioLibraryVisible" class="studio_float_panel studio_library_panel" @click.stop>
                <div class="studio_float_head">
                    <span>背景库</span>
                    <button type="button" @click="fetchStudioBackgrounds(true)">
                        {{ studioLibraryLoading ? "读取中" : "刷新" }}
                    </button>
                </div>
                <div v-if="studioBackgrounds.length" class="studio_library_grid">
                    <button
                        v-for="item in studioBackgrounds"
                        :key="item.id"
                        type="button"
                        class="studio_library_item"
                        :class="{ active: studioBackground === item.url }"
                        @click="applyStudioLibraryBackground(item)"
                    >
                        <span :style="{ backgroundImage: `url(${item.url})` }"></span>
                        <em>{{ item.name }}</em>
                    </button>
                </div>
                <div v-else class="studio_empty">
                    {{ studioLibraryLoading ? "正在读取背景" : studioLibraryError || "暂无背景" }}
                </div>
            </div>
            <div v-if="editorType === 'studio' && studioAdjustVisible" class="studio_float_panel studio_adjust_panel" @click.stop>
                <div class="studio_float_head">
                    <span>背景调整</span>
                    <button type="button" @click="resetStudioBackgroundAdjust">重置</button>
                </div>
                <div class="studio_adjust_row">
                    <span>左右</span>
                    <van-slider v-model="studioBackgroundAdjust.x" :min="-300" :max="300" :step="1" bar-height="3px" @input="applyStudioBackgroundAdjust" />
                    <em>{{ studioBackgroundAdjust.x }}</em>
                </div>
                <div class="studio_adjust_row">
                    <span>上下</span>
                    <van-slider v-model="studioBackgroundAdjust.y" :min="-300" :max="300" :step="1" bar-height="3px" @input="applyStudioBackgroundAdjust" />
                    <em>{{ studioBackgroundAdjust.y }}</em>
                </div>
                <div class="studio_adjust_row">
                    <span>缩放</span>
                    <van-slider v-model="studioBackgroundAdjust.scale" :min="0.8" :max="2" :step="0.01" bar-height="3px" @input="applyStudioBackgroundAdjust" />
                    <em>{{ Math.round(studioBackgroundAdjust.scale * 100) }}%</em>
                </div>
                <div class="studio_adjust_row">
                    <span>明暗</span>
                    <van-slider v-model="studioBackgroundAdjust.brightness" :min="45" :max="160" :step="1" bar-height="3px" @input="applyStudioBackgroundAdjust" />
                    <em>{{ studioBackgroundAdjust.brightness }}%</em>
                </div>
            </div>
            <div class="count_down" v-if="$store.state.routeParams.mode === 'edit' && $store.state.routeParams.type !== 'practice'">
                {{ countdown }}
            </div>
            <div v-show="actActived" class="act_panel" :class="{ container_act_panel: actived === 9 }">
                <div class="act_detail lv_flexalign_center">
                    <winding v-show="actived === 0" ref="winding" />
                    <flower-head v-show="actived === 1" ref="flowerHead" />
                    <stem v-show="actived === 3" ref="stem" />
                    <remove v-show="actived === 4" :selectedMaterial="selectedMaterial" />
                    <copy v-show="actived === 5" :selectedMaterial="selectedMaterial" />
                    <touch v-show="actived === 6" />
                    <canvas-lock v-show="actived === 7" />
                    <container v-show="actived === 9" />
                    <jianshan v-show="actived === 10" />
                    <bindType v-show="actived === 11" />
                    <angle v-show="actived === 12" />
                    <flower-height v-show="actived === 13" />
                    <change-camera v-show="actived === 14" />
                    <background v-show="actived === 15" />
                </div>
            </div>
            <div class="bottom_tool_strip">
                <button type="button" class="bottom_tool material_catalog_tool" data-guide="material-catalog" @click="openMaterialCatalog">
                    <van-icon name="photo-o" />
                    <span>花材/容器</span>
                </button>
                <div class="bottom_tools_grid">
                    <button
                        type="button"
                        v-for="item in visibleActs"
                        :key="item.index"
                        class="bottom_tool"
                        :data-guide="getToolGuideId(item.index)"
                        :class="{
                            bottom_tool_active: isBottomToolActive(item.index),
                            bottom_tool_disabled: isToolLocked(item.index),
                            hide: item.index === 8 && $store.state.routeParams.type !== 'practice',
                        }"
                        @click="handleClick(item.index)"
                    >
                        {{ item.label }}
                    </button>
                </div>
            </div>
            <div v-if="$store.state.routeParams.type !== 'practice'" class="work_bar lv_flex">
                <div class="lv_flex_center" @click="reqShow = true">
                    <i class="iconfont icon-tiezi"></i>
                    {{ $store.state.routeParams.text }}要求
                </div>
                <div class="lv_flex_center" @click="inputShow = true">
                    <i class="iconfont icon-fenxiang"></i>
                    填写描述
                </div>
            </div>
        </template>
        <div v-else-if="$store.state.routeParams.type !== 'practice'">
            <div class="lv_flex exam_bar">
                <div @click="reqShow = true">作业要求</div>
                <div @click="$refs.choosePop.open()">可用素材</div>
                <div @click="inputShow = true">作业描述</div>
                <div v-if="$store.state.routeParams.type === 'schoolwork' && info.status === 3" @click="teacher.show = true">老师评语</div>
            </div>
        </div>

        <van-popup v-model="reqShow" position="bottom" round>
            <div class="req_poup">
                <div v-if="$store.state.routeParams.type === 'schoolwork'">
                    <div class="label">关联课件（必看）</div>
                    <div class="link lv_flexalign_center" @click="coursewareShow = true">
                        <i class="iconfont icon-kaifang" />
                        {{ info.coursewareTitle }}
                    </div>
                </div>
                <div>
                    <div class="label">{{ $store.state.routeParams.text }}要求</div>
                    <div class="text">{{ info.request }}</div>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="inputShow" position="bottom" round>
            <div class="input_pop">
                <van-field v-model="form.name" label="作品命名" required placeholder="填写作品名称" :readonly="$store.state.routeParams.mode === 'examine'" />

                <van-field required v-model="form.desc" rows="3" label="填写描述" type="textarea" placeholder="填写作品描述" :readonly="$store.state.routeParams.mode === 'examine'" v-if="hasDesc" />
            </div>
        </van-popup>

        <van-popup v-model="teacher.show" position="bottom" round>
            <div class="input_pop">
                <van-field v-model="teacher.res" label="作业结果" readonly />

                <van-field readonly v-model="teacher.desc" rows="3" label="老师评语" type="textarea" placeholder="填写作品描述" />
            </div>
        </van-popup>

        <van-dialog v-model="coursewareShow" title="查看课件" confirmButtonText="关闭">
            <video id="ls_vedio" autoplay="true" controls="true" v-if="coursewareShow">
                <source :src="info.coursewareUrl" type="video/mp4" />
            </video>
        </van-dialog>
        <van-popup v-model="risoShow" position="right" :style="{ width: '80%', height: '100vh' }" round>
            <van-collapse v-model="activeNames" v-if="selectedMaterial">
                <van-collapse-item :title="item" :name="key" v-for="(item, key) in tabs" :key="key">
                    <div v-if="key === 'basicInfo'" style="color: #ff8f2f">名称：{{ selectedMaterial.name }}</div>
                    {{ selectedMaterial.resource[key] }}
                </van-collapse-item>
            </van-collapse>
        </van-popup>
        <van-popup
            v-model="scoreShow"
            position="bottom"
            round
            :overlay="true"
            :overlay-style="{ pointerEvents: 'auto' }"
            :close-on-click-overlay="true"
            @click-overlay="closeScorePopup"
        >
            <div class="score_pop" v-if="scoreResult">
                <div class="score_head">
                    <div>
                        <span>作品评估</span>
                        <strong>{{ scoreResult.totalScore }}</strong>
                    </div>
                    <p>{{ scoreResult.summary }}</p>
                </div>
                <div class="score_metrics">
                    <div v-for="metric in scoreResult.metrics" :key="metric.key" class="score_metric">
                        <div class="metric_title">
                            <span>{{ metric.name }}</span>
                            <strong>{{ metric.score }}</strong>
                        </div>
                        <div class="metric_bar">
                            <div :style="{ width: metric.score + '%' }" />
                        </div>
                        <p>{{ metric.comment }}</p>
                    </div>
                </div>
                <div class="score_suggestions">
                    <div class="suggestion_title">调整建议</div>
                    <div v-for="(item, index) in scoreResult.suggestions" :key="index" class="suggestion_item">
                        {{ item }}
                    </div>
                </div>
            </div>
        </van-popup>
        <choosePop ref="choosePop" />
    </div>
</template>

<script>
import wx from "weixin-js-sdk";
import choosePop from "@/components/material/choosePop";
import winding from "@/components/act/winding";
import flowerHead from "@/components/act/flowerHead";
import stem from "@/components/act/stem";
import remove from "@/components/act/remove";
import touch from "@/components/act/touch";
import bindType from "@/components/act/bindType";
import angle from "@/components/act/angle";
import copy from "@/components/act/copy";
import container from "@/components/act/container";
import jianshan from "@/components/act/jianshan.vue";
import background from "@/components/act/background.vue";
import canvasLock from "@/components/act/canvasLock.vue";
import flowerHeight from "@/components/act/flowerHeight.vue";
import changeCamera from "@/components/act/changeCamera.vue";

import { Dialog, Toast } from "vant";
import dayjs from "dayjs";
export default {
    components: {
        copy,
        winding,
        flowerHead,
        stem,
        remove,
        touch,
        bindType,
        angle,
        container,
        jianshan,
        choosePop,
        canvasLock,
        flowerHeight,
        changeCamera,
        background,
    },
    data() {
        return {
            tabs: {
                basicInfo: "基础信息",
                collocation: "插花搭配",
                connotation: "文化内涵",
                colorSuggestion: "色彩搭配",
                compositionSuggestion: "构图建议",
                technicalSuggestion: "技术特点",
            },
            activeNames: ["basicInfo"],
            risoShow: false,
            teacher: {
                show: false,
                desc: null,
                res: "通过",
            },
            form: {
                name: null,
                desc: null,
            },
            inputShow: false,
            coursewareShow: false,
            reqShow: false,
            info: "",
            countdown: "",
            hasDesc: false,
            tId: null,
            actActived: false,
            layerPanelVisible: true,
            selectedMaterial: null,
            containerMaterial: null,
            flowerHeightShow: false,
            scoreShow: false,
            scoreResult: null,
            focusActive: true,
            jianshanActive: false,
            editorType: "free3d",
            modeSwitchPosition: null,
            modeSwitchDragState: null,
            suppressModeSwitchClick: false,
            studioPreset: "warm",
            studioBackground: "",
            studioBackgroundSource: "",
            studioToolbarExpanded: false,
            studioPresetMenuVisible: false,
            studioLibraryVisible: false,
            studioLibraryLoading: false,
            studioLibraryLoaded: false,
            studioLibraryError: "",
            studioBackgrounds: [],
            studioBackgroundHost: "https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/",
            studioAdjustVisible: false,
            studioBackgroundAdjust: {
                x: 0,
                y: 0,
                scale: 1,
                brightness: 100,
                contrast: 100,
            },
            studioPresets: [
                { value: "white", label: "白棚" },
                { value: "warm", label: "暖棚" },
                { value: "gray", label: "灰棚" },
                { value: "dark", label: "暗棚" },
            ],
            actived: 0,
            acts: ["弯曲", "花头", "图层", "根茎", "删除", "复制", "焦点", "画布", "替换", "容器", "剑山", "插法", "角度", "花高", "缩放", "背景"],
        };
    },
    computed: {
        visibleActs() {
            // 临时隐藏“角度”“花高”两个工具栏入口，后续如需恢复，
            // 只要把 12 和 13 从下面这个数组里移除即可。
            const hiddenActIndexes = [12, 13];
            const orderedActIndexes = [0, 2, 1, 4, 9, 5, 6, 7, 8, 3, 10, 11, 14, 15];
            return orderedActIndexes
                .filter(index => !hiddenActIndexes.includes(index))
                .map(index => ({
                    label: this.acts[index],
                    index,
                }));
        },
        currentStudioPresetLabel() {
            const activePreset = this.studioPresets.find(item => item.value === this.studioPreset);
            return activePreset ? activePreset.label : "棚景";
        },
        modeSwitchStyle() {
            if (!this.modeSwitchPosition) {
                return {};
            }
            return {
                left: `${this.modeSwitchPosition.left}px`,
                right: "auto",
                top: `${this.modeSwitchPosition.top}px`,
            };
        },
    },
    created() {
        this.editorType = this.getRouteEditorType();
        this.studioToolbarExpanded = this.editorType === "studio";
        this.$bus.$on("flower-height-show", val => {
            this.flowerHeightShow = val;
        });

        this.$bus.$on("container-add", val => {
            this.containerMaterial = val;
            if (!val && this.requiresContainerSelection(this.actived)) {
                this.actived = 6;
                this.actActived = false;
            }
        });

        this.$bus.$on("flower-choose", val => {
            // if (this.selectedMaterial && this.selectedMaterial.id === val.id) {
            //   return;
            // }
            this.selectedMaterial = val;

            if (!val) {
                if (this.requiresMaterialSelection(this.actived)) {
                    this.actived = 6;
                    this.actActived = false;
                }
                if (this.$refs.stem) {
                    this.$refs.stem.init(null);
                }
                return;
            }
            this.$refs.winding.init(val);
            this.$refs.flowerHead.init(val);
            if (this.$refs.stem) {
                this.$refs.stem.init(val);
            }
        });

        this.$bus.$on("layer-panel-visible-change", visible => {
            this.layerPanelVisible = visible;
            if (!visible && this.actived === 2) {
                this.actived = 0;
            }
        });

        this.$bus.$on("setTouchHelper", visible => {
            this.focusActive = !!visible;
        });

        this.$bus.$on("touch-helper-change", visible => {
            this.focusActive = !!visible;
        });

        this.$bus.$on("showJsContainer", visible => {
            this.jianshanActive = !!visible;
        });

        this.$bus.$on("jianshan-visible-change", visible => {
            this.jianshanActive = !!visible;
        });

        this.$bus.$on("jianshan-reset", val => {
            this.jianshanActive = !val || val.visible !== false;
        });

        this.$bus.$on("editor-type-change", type => {
            this.editorType = type === "studio" ? "studio" : "free3d";
            this.studioToolbarExpanded = this.editorType === "studio";
            this.studioPresetMenuVisible = false;
            this.closeStudioPanels();
            this.$store.commit("initParams", {
                ...this.$route.query,
                editorType: this.editorType,
            });
        });

        this.$bus.$on("studio-state-change", studio => {
            const state = studio || {};
            this.studioPreset = state.backgroundType || "warm";
            this.studioBackground = state.backgroundImage || "";
            this.studioBackgroundSource = this.studioBackground ? this.getStudioBackgroundSource(this.studioBackground) : "";
            this.studioBackgroundAdjust = this.normalizeStudioBackgroundAdjust(state.backgroundAdjust);
        });

        this.$bus.$on("artwork-score-result", result => {
            this.scoreResult = result;
            this.scoreShow = true;
        });
    },
    mounted() {
        document.addEventListener("click", this.handleDocumentClick);
        window.addEventListener("resize", this.keepModeSwitchInViewport);
        this.$bus.$on("guide-open-material", this.openMaterialCatalog);
        this.$bus.$on("guide-open-tool", this.openGuideTool);
        this.$bus.$on("guide-close-tool-panel", this.closeGuideToolPanel);
        if (this.$store.state.routeParams.type !== "practice") {
            this.getRequest(this.$store.state.routeParams.type);
        }
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleDocumentClick);
        window.removeEventListener("resize", this.keepModeSwitchInViewport);
        this.stopModeSwitchDrag();
        this.$bus.$off("guide-open-material", this.openMaterialCatalog);
        this.$bus.$off("guide-open-tool", this.openGuideTool);
        this.$bus.$off("guide-close-tool-panel", this.closeGuideToolPanel);
    },
    methods: {
        startModeSwitchDrag(event) {
            if ((event.pointerType === "mouse" && event.button !== 0) || !this.$refs.editorModeSwitch) {
                return;
            }
            const rect = this.$refs.editorModeSwitch.getBoundingClientRect();
            this.modeSwitchPosition = {
                left: rect.left,
                top: rect.top,
            };
            this.modeSwitchDragState = {
                pointerId: event.pointerId,
                startX: event.clientX,
                startY: event.clientY,
                offsetX: event.clientX - rect.left,
                offsetY: event.clientY - rect.top,
                width: rect.width,
                height: rect.height,
                moved: false,
            };
            window.addEventListener("pointermove", this.moveModeSwitch, { passive: false });
            window.addEventListener("pointerup", this.finishModeSwitchDrag);
            window.addEventListener("pointercancel", this.finishModeSwitchDrag);
        },
        moveModeSwitch(event) {
            const dragState = this.modeSwitchDragState;
            if (!dragState || event.pointerId !== dragState.pointerId) {
                return;
            }
            if (
                !dragState.moved &&
                Math.hypot(event.clientX - dragState.startX, event.clientY - dragState.startY) > 4
            ) {
                dragState.moved = true;
            }
            if (!dragState.moved) {
                return;
            }
            if (event.cancelable) {
                event.preventDefault();
            }
            const edgeGap = 8;
            const maxLeft = Math.max(edgeGap, window.innerWidth - dragState.width - edgeGap);
            const maxTop = Math.max(edgeGap, window.innerHeight - dragState.height - edgeGap);
            this.modeSwitchPosition = {
                left: Math.min(Math.max(edgeGap, event.clientX - dragState.offsetX), maxLeft),
                top: Math.min(Math.max(edgeGap, event.clientY - dragState.offsetY), maxTop),
            };
        },
        finishModeSwitchDrag(event) {
            if (!this.modeSwitchDragState || (event && event.pointerId !== this.modeSwitchDragState.pointerId)) {
                return;
            }
            const moved = this.modeSwitchDragState.moved;
            this.stopModeSwitchDrag();
            if (moved) {
                this.suppressModeSwitchClick = true;
                window.setTimeout(() => {
                    this.suppressModeSwitchClick = false;
                }, 120);
            }
        },
        stopModeSwitchDrag() {
            window.removeEventListener("pointermove", this.moveModeSwitch);
            window.removeEventListener("pointerup", this.finishModeSwitchDrag);
            window.removeEventListener("pointercancel", this.finishModeSwitchDrag);
            this.modeSwitchDragState = null;
        },
        keepModeSwitchInViewport() {
            if (!this.modeSwitchPosition || !this.$refs.editorModeSwitch) {
                return;
            }
            const rect = this.$refs.editorModeSwitch.getBoundingClientRect();
            const edgeGap = 8;
            this.modeSwitchPosition = {
                left: Math.min(
                    Math.max(edgeGap, this.modeSwitchPosition.left),
                    Math.max(edgeGap, window.innerWidth - rect.width - edgeGap)
                ),
                top: Math.min(
                    Math.max(edgeGap, this.modeSwitchPosition.top),
                    Math.max(edgeGap, window.innerHeight - rect.height - edgeGap)
                ),
            };
        },
        handleDocumentClick(event) {
            if (this.scoreShow && event.target && event.target.closest && event.target.closest(".van-overlay")) {
                this.closeScorePopup();
                return;
            }
            if (!this.actActived || !event.target || this.$store.state.routeParams.mode !== "edit") {
                this.handleStudioOutsideClick(event);
                return;
            }
            const ignoreSelector = ".act_panel, .bottom_tool_strip, .practice_guide, .top_left_group, .top_action_group, .editor_mode_switch, .studio_toolbar, .studio_float_panel, .van-popup, .van-overlay";
            if (event.target.closest && event.target.closest(ignoreSelector)) {
                return;
            }
            this.actActived = false;
            this.handleStudioOutsideClick(event);
        },
        handleStudioOutsideClick(event) {
            if (!event || !event.target || (!this.studioLibraryVisible && !this.studioAdjustVisible && !this.studioPresetMenuVisible)) {
                return;
            }
            const ignoreSelector = ".studio_toolbar, .studio_float_panel";
            if (event.target.closest && event.target.closest(ignoreSelector)) {
                return;
            }
            this.closeStudioPanels();
        },
        getRouteEditorType() {
            return this.$route.path === "/studio" || this.$route.query.editorType === "studio" ? "studio" : "free3d";
        },
        closeStudioPanels() {
            this.studioLibraryVisible = false;
            this.studioAdjustVisible = false;
            this.studioPresetMenuVisible = false;
        },
        toggleStudioToolbar() {
            this.studioToolbarExpanded = !this.studioToolbarExpanded;
            this.studioPresetMenuVisible = false;
            if (!this.studioToolbarExpanded) {
                this.closeStudioPanels();
            }
        },
        toggleStudioPresetMenu() {
            const nextVisible = !this.studioPresetMenuVisible;
            this.studioLibraryVisible = false;
            this.studioAdjustVisible = false;
            this.studioToolbarExpanded = true;
            this.studioPresetMenuVisible = nextVisible;
        },
        setStudioPreset(preset) {
            if (this.editorType !== "studio") {
                return;
            }
            this.studioPreset = preset || "warm";
            this.studioBackground = "";
            this.studioBackgroundSource = "";
            this.closeStudioPanels();
            this.studioToolbarExpanded = true;
            this.$bus.$emit("setStudioPreset", this.studioPreset);
            Toast("已切换棚景效果");
        },
        setStudioBackground(url, source) {
            if (this.editorType !== "studio") {
                return;
            }
            this.studioBackground = url || "";
            this.studioBackgroundSource = this.studioBackground ? source || this.getStudioBackgroundSource(this.studioBackground) : "";
            this.$bus.$emit("setStudioBackground", this.studioBackground);
        },
        getStudioBackgroundSource(url) {
            return /^data:|^blob:/i.test(url || "") ? "upload" : "library";
        },
        resolveStudioBackgroundUrl(url) {
            if (!url) {
                return "";
            }
            if (/^https?:\/\//i.test(url) || url.startsWith("//") || /^data:|^blob:/i.test(url)) {
                return url;
            }
            return `${this.studioBackgroundHost}${url.replace(/^\/+/, "")}`;
        },
        toggleStudioLibrary() {
            this.studioLibraryVisible = !this.studioLibraryVisible;
            this.studioToolbarExpanded = true;
            this.studioPresetMenuVisible = false;
            if (this.studioLibraryVisible) {
                this.studioAdjustVisible = false;
            }
            if (this.studioLibraryVisible && !this.studioLibraryLoaded && !this.studioLibraryLoading) {
                this.fetchStudioBackgrounds();
            }
        },
        toggleStudioAdjust() {
            this.studioAdjustVisible = !this.studioAdjustVisible;
            this.studioToolbarExpanded = true;
            this.studioPresetMenuVisible = false;
            if (this.studioAdjustVisible) {
                this.studioLibraryVisible = false;
            }
        },
        async fetchStudioBackgrounds(force = false) {
            if (this.studioLibraryLoading || (this.studioLibraryLoaded && !force)) {
                return;
            }
            this.studioLibraryLoading = true;
            this.studioLibraryError = "";
            try {
                const res = await this.$ajax.post("/material/hrss/queryFlowerList", {
                    classifyId1: 63,
                    pageIndex: 1,
                    pageSize: 24,
                });
                this.studioBackgrounds = (res.list || []).map(item => ({
                    ...item,
                    url: this.resolveStudioBackgroundUrl(item.thumbnailImage),
                }));
                this.studioLibraryLoaded = true;
            } catch (error) {
                this.studioLibraryError = "背景读取失败";
            } finally {
                this.studioLibraryLoading = false;
            }
        },
        applyStudioLibraryBackground(item) {
            this.setStudioBackground(item.url, "library");
            this.studioLibraryVisible = false;
            Toast("已应用棚景背景");
        },
        triggerStudioBackgroundUpload() {
            this.closeStudioPanels();
            this.studioToolbarExpanded = true;
            if (this.$refs.studioBackgroundInput) {
                this.$refs.studioBackgroundInput.click();
            }
        },
        async handleStudioBackgroundUpload(event) {
            const input = event.target;
            const file = input.files && input.files[0];
            if (!file) {
                return;
            }
            if (!/^image\//.test(file.type)) {
                Toast("请选择图片文件");
                input.value = "";
                return;
            }
            try {
                const dataUrl = await this.readStudioBackgroundFile(file);
                this.setStudioBackground(dataUrl, "upload");
                Toast("本地棚景背景已应用");
            } catch (error) {
                Toast("棚景背景读取失败");
            } finally {
                input.value = "";
            }
        },
        readStudioBackgroundFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    this.compressStudioBackground(reader.result)
                        .then(resolve)
                        .catch(() => resolve(reader.result));
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        compressStudioBackground(dataUrl) {
            return new Promise(resolve => {
                const image = new Image();
                image.onload = () => {
                    const maxSize = 1600;
                    const sourceWidth = image.naturalWidth || image.width;
                    const sourceHeight = image.naturalHeight || image.height;
                    const scale = Math.min(1, maxSize / Math.max(sourceWidth, sourceHeight));
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
                    canvas.width = Math.round(sourceWidth * scale);
                    canvas.height = Math.round(sourceHeight * scale);
                    ctx.fillStyle = "#ffffff";
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                    resolve(canvas.toDataURL("image/jpeg", 0.88));
                };
                image.onerror = () => resolve(dataUrl);
                image.src = dataUrl;
            });
        },
        clearStudioBackground() {
            this.setStudioBackground("", "");
            this.closeStudioPanels();
            this.studioToolbarExpanded = true;
            Toast("已清除棚景背景");
        },
        normalizeStudioBackgroundAdjust(config = {}) {
            const clampValue = (value, min, max, fallback) => {
                const numberValue = Number(value);
                if (!Number.isFinite(numberValue)) {
                    return fallback;
                }
                return Math.min(max, Math.max(min, numberValue));
            };
            return {
                x: clampValue(config.x, -300, 300, 0),
                y: clampValue(config.y, -300, 300, 0),
                scale: clampValue(config.scale, 0.8, 2, 1),
                brightness: clampValue(config.brightness, 45, 160, 100),
                contrast: clampValue(config.contrast, 50, 150, 100),
            };
        },
        applyStudioBackgroundAdjust() {
            this.studioBackgroundAdjust = this.normalizeStudioBackgroundAdjust(this.studioBackgroundAdjust);
            this.$bus.$emit("setStudioBackgroundAdjust", this.studioBackgroundAdjust);
        },
        resetStudioBackgroundAdjust() {
            this.studioBackgroundAdjust = this.normalizeStudioBackgroundAdjust();
            this.applyStudioBackgroundAdjust();
        },
        requiresMaterialSelection(index) {
            return [0, 1, 3, 4, 5, 8].includes(index);
        },
        requiresContainerSelection(index) {
            return index === 9;
        },
        isMaterialToolLocked(index) {
            return this.requiresMaterialSelection(index) && !this.selectedMaterial;
        },
        isContainerToolLocked(index) {
            return this.requiresContainerSelection(index) && !this.containerMaterial;
        },
        isToolLocked(index) {
            return this.isMaterialToolLocked(index) || this.isContainerToolLocked(index);
        },
        isBottomToolActive(index) {
            if (this.isToolLocked(index)) {
                return false;
            }
            if (index === 2) {
                return this.layerPanelVisible;
            }
            if (index === 6) {
                return this.focusActive;
            }
            if (index === 10) {
                return this.jianshanActive;
            }
            return index === this.actived && this.actActived;
        },
        getToolGuideId(index) {
            const guideMap = {
                0: "tool-bend",
                1: "tool-flower-head",
                2: "tool-layer",
                3: "tool-stem",
                6: "tool-focus",
                9: "tool-container",
            };
            return guideMap[index] || null;
        },
        getLockedToolMessage(index) {
            if (this.isContainerToolLocked(index)) {
                return "请先添加容器后可使用";
            }
            return "请选素材后可使用";
        },
        openRiso() {
            if (!this.selectedMaterial) {
                return;
            }
            this.activeNames = ["basicInfo"];
            this.risoShow = true;
        },
        scoreArtwork() {
            this.actActived = false;
            this.$bus.$emit("score-artwork");
        },
        closeScorePopup() {
            this.scoreShow = false;
        },
        openMaterialCatalog(type) {
            const materialType = typeof type === "number" ? type : 1;
            this.actActived = false;
            this.$refs.choosePop.open(null, materialType);
            this.$bus.$emit("guide-material-popup-open", materialType);
        },
        openGuideTool(index, retryCount = 0) {
            if (this.isToolLocked(index)) {
                if (retryCount < 4) {
                    setTimeout(() => {
                        this.openGuideTool(index, retryCount + 1);
                    }, 180);
                }
                return;
            }
            this.actived = index;
            if (index === 2) {
                this.actActived = false;
                this.layerPanelVisible = true;
                this.$bus.$emit("layer-panel-show");
                return;
            }
            if (index === 6) {
                this.actActived = false;
                return;
            }
            this.actActived = true;
        },
        closeGuideToolPanel() {
            this.actActived = false;
        },
        async toDesign() {
            await this.save("design");
            // const queryParams = new URLSearchParams(window.location.search);
            // const params = {};
            // for (const [key, value] of queryParams.entries()) {
            //     params[key] = value;
            // }
            // if (window.location.hash) {
            //     const hashParams = new URLSearchParams(window.location.hash.slice(window.location.hash.indexOf('?') + 1));
            //     for (const [key, value] of hashParams.entries()) {
            //         params[key] = value;
            //     }
            // }
            // console.log(params);
            // this.$router.push({
            //     path: "/design",
            //     query: params,
            // })
        },
        getRequest(type) {
            this.$ajax
                .get(`/${type}/student/getById`, {
                    params: {
                        id: this.$store.state.routeParams.id,
                    },
                })
                .then(res => {
                    const resData = res.data;
                    this.info = {
                        name: resData[type + "Name"],
                        request: resData[type + "Request"],
                        useMaterials: resData[type + "UseMaterials"],
                        submitEndTime: type === "competition" ? resData.competitionEndTime : resData.submitEndTime,
                        hasTimeout: resData.hasTimeout,
                        coursewareTitle: resData.coursewareTitle,
                        coursewareUrl: resData.coursewareUrl,
                        status: resData.status,
                    };
                    sessionStorage.setItem("startTime", new Date().getTime());
                    this.hasDesc = type === "competition" ? true : resData.hasDesc;
                    sessionStorage.setItem("limit", JSON.stringify(resData[type + "UseMaterials"][0].useMaterials));
                    this.$store.commit("initLimitMaterials", resData[type + "UseMaterials"]);

                    if (this.$store.state.routeParams.mode === "examine") {
                        this.form.name = resData.productName;
                        this.form.desc = resData[type + "Desc"];
                        document.title = resData.productName;
                        if (this.$store.state.routeParams.type === "schoolwork") {
                            this.teacher.desc = resData.schoolworkRemark;
                        }
                    }

                    this.countDown(resData.hasTimeout);
                    this.tId = setInterval(() => {
                        this.countDown(resData.hasTimeout);
                    }, 1000);
                });
        },
        countDown(hasTimeout) {
            var subtime = (dayjs(this.info.submitEndTime) - dayjs()) / 1000;

            var days = parseInt(subtime / 86400);
            var hours = parseInt(subtime / 3600) - 24 * days;
            var minutes = parseInt((subtime % 3600) / 60);
            var seconds = parseInt(subtime % 60);

            if (hours <= 0 && minutes <= 0 && seconds <= 0 && this.$store.state.routeParams.mode === "edit") {
                clearInterval(this.tId);
                if (hasTimeout) {
                    this.countdown = "已经超时";
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: "作答时间已到",
                    }).then(() => {
                        this.wxReturn();
                    });
                }
            } else {
                this.countdown = `${days}天 ${hours}小时 ${minutes}分 ${seconds} 秒`;
            }
        },
        wxReturn() {
            wx.miniProgram.navigateBack({});
        },
        startNoviceGuide() {
            this.actActived = false;
            this.$bus.$emit("practice-guide-start");
        },
        switchEditorType(type) {
            if (this.suppressModeSwitchClick) {
                return;
            }
            const nextType = type === "studio" ? "studio" : "free3d";
            if (nextType === this.editorType) {
                return;
            }
            Dialog.confirm({
                title: "切换编辑器",
                message: "3D自由编辑器和棚景编辑器互相独立，切换前请先保存当前作品。确认切换吗？",
                confirmButtonText: "确认切换",
                cancelButtonText: "先不切换",
            })
                .then(() => {
                    this.actActived = false;
                    this.editorType = nextType;
                    this.$store.commit("initParams", {
                        ...this.$route.query,
                        editorType: nextType,
                    });
                    this.$bus.$emit("switch-editor-type", nextType);
                    this.$router.replace({
                        path: nextType === "studio" ? "/studio" : "/practice",
                        query: {
                            ...this.$route.query,
                            editorType: nextType,
                        },
                    });
                    Toast(nextType === "studio" ? "已切换棚景编辑器" : "已切换3D自由编辑器");
                })
                .catch(() => {});
        },
        handleClick(index) {
            if (this.isToolLocked(index)) {
                Toast(this.getLockedToolMessage(index));
                return;
            }
            if (index === 5) {
                this.actActived = false;
                this.$bus.$emit("copy", this.selectedMaterial.id);
                this.$bus.$emit("guide-tool-click", index);
                return;
            }
            if (index === 2) {
                this.actActived = false;
                this.layerPanelVisible = !this.layerPanelVisible;
                this.$bus.$emit("layer-panel-toggle");
                this.actived = this.layerPanelVisible ? index : 0;
                this.$bus.$emit("guide-tool-click", index);
                return;
            }
            if (index === 6) {
                this.actActived = false;
                this.actived = index;
                const nextFocusActive = !this.focusActive;
                this.$bus.$emit("setTouchHelper", nextFocusActive);
                Toast(nextFocusActive ? "已开启焦点" : "已关闭焦点");
                this.$bus.$emit("guide-tool-click", index);
                return;
            }
            this.actived = index;
            if (index === 8) {
                this.actActived = false;
                this.$refs.choosePop.open({
                    classifyId1: 1,
                    id: this.selectedMaterial ? this.selectedMaterial.id : null,
                });
                this.$bus.$emit("guide-tool-click", index);
                return;
            }
            this.actActived = true;
            this.$bus.$emit("guide-tool-click", index);
        },
        save(type) {
            if (type && typeof type === "object") {
                type = "";
            }
            if (this.$store.state.routeParams.type === "practice") {
                this.$bus.$emit("save", "practice", "", type);
            } else {
                if (!this.form.name || (!this.form.desc && this.hasDesc)) {
                    Toast("请点击右下角，完善要求");
                    return;
                }

                Dialog.confirm({
                    title: "提交" + this.$store.state.routeParams.text,
                    message: `提交前请检查是否完成，确认是否提交${this.$store.state.routeParams.text}？`,
                })
                    .then(() => {
                        this.$bus.$emit("save", "work", this.form);
                    })
                    .catch(() => {});
            }
        },
    },
};
</script>
<style lang="scss">
.slider_text {
    width: rem(90);
    text-align: center;
}

.van-collapse-item {
    .van-cell__title {
        text-align: center;
    }
}

.exam_bar {
    margin: rem(20);
    background: #fff;
    font-weight: bold;
    border-radius: rem(10);
    border: 1px solid #dedede;
    padding: rem(20) 0;

    > div {
        line-height: rem(50);
        font-size: rem(28);
        flex: 1;
        text-align: center;

        + div {
            border-left: 1px solid #dcdcdc;
        }
    }
}

.act_button {
    flex: 1;
    line-height: rem(40);
    border: 1px solid #dcdcdc;
    border-radius: rem(14);
    text-align: center;
    font-size: rem(24);
    background: #fff;
}

.act_button + .act_button {
    margin-left: rem(20);
}

.actived {
    background: #e8efd5;
}
</style>
<style lang="scss" scoped>
.mb-10 {
    margin-bottom: rem(10);
}

.selected_bar {
    width: rem(90);
    padding: rem(10) rem(5);
    box-sizing: border-box;
    position: fixed;
    top: rem(280);
    border-radius: rem(14);
    left: rem(27);
    background: #f7f7f7;
    border: 1px solid #dcdcdc;
    font-size: rem(20);
    color: #333;
}

.riso_bar {
    position: fixed;
    right: rem(18);
    top: rem(98);
    height: rem(53);
    width: rem(160);
    border: 1px solid #dcdcdc;

    border-radius: rem(27);
    background: #fff;
    color: #d6d6d6;

    > div {
        width: rem(16);
        height: rem(16);
        background: #dcdcdc;
        border-radius: 50%;
        margin: 0 rem(15);
    }
}

.top_left_group {
    position: fixed;
    left: rem(18);
    top: rem(28);
    display: flex;
    align-items: center;
    z-index: 16;
}

.top_exit_button,
.top_guide_button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: rem(58);
    padding: 0 rem(20);
    border: 1px solid rgba(220, 226, 211, 0.9);
    border-radius: rem(29);
    background: rgba(255, 255, 255, 0.96);
    color: #2f382e;
    font-size: rem(24);
    font-weight: bold;
    box-shadow: 0 rem(6) rem(18) rgba(40, 55, 32, 0.1);

    .van-icon {
        margin-right: rem(6);
        font-size: rem(28);
    }
}

.top_exit_button {
    min-width: rem(118);
}

.top_guide_button {
    min-width: rem(152);
    margin-left: rem(10);
    color: #6e9f21;
    border-color: rgba(183, 212, 123, 0.92);
}

.top_action_group {
    position: fixed;
    right: rem(18);
    top: rem(28);
    display: flex;
    align-items: center;
    padding: rem(5);
    border: 1px solid rgba(220, 226, 211, 0.9);
    border-radius: rem(33);
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 rem(6) rem(18) rgba(40, 55, 32, 0.1);
    z-index: 16;
}

.top_action_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: rem(52);
    min-width: rem(104);
    padding: 0 rem(18);
    border: 0;
    border-radius: rem(26);
    background: transparent;
    color: #4f5a4a;
    font-size: rem(24);
    font-weight: bold;

    .van-icon {
        margin-right: rem(6);
        font-size: rem(28);
    }

    + .top_action_btn {
        margin-left: rem(4);
    }
}

.top_save_btn {
    background: #6e9f21;
    color: #fff;
    box-shadow: 0 rem(6) rem(14) rgba(110, 159, 33, 0.24);
}

.top_score_btn {
    background: #e8efd5;
    color: #4f7c16;
}

.editor_mode_switch {
    position: fixed;
    right: rem(18);
    top: rem(104);
    display: flex;
    align-items: center;
    padding: rem(4);
    border: 1px solid rgba(220, 226, 211, 0.88);
    border-radius: rem(29);
    background: rgba(255, 255, 255, 0.88);
    box-shadow: 0 rem(6) rem(18) rgba(40, 55, 32, 0.08);
    z-index: 17;
    cursor: grab;
    touch-action: none;
    user-select: none;

    &.dragging {
        cursor: grabbing;
    }

    button {
        height: rem(46);
        min-width: rem(72);
        padding: 0 rem(16);
        border: 0;
        border-radius: rem(23);
        background: transparent;
        color: #65705f;
        font-size: rem(22);
        font-weight: bold;
    }

    button.active {
        background: #6e9f21;
        color: #fff;
        box-shadow: 0 rem(4) rem(10) rgba(110, 159, 33, 0.2);
    }
}

.studio_toolbar {
    position: fixed;
    right: rem(18);
    top: rem(172);
    z-index: 15;
    display: flex;
    align-items: center;
    width: max-content;
    max-width: calc(100vw - #{rem(28)});
    padding: rem(4) rem(6);
    overflow: visible;
    border: 1px solid rgba(220, 226, 211, 0.72);
    border-radius: rem(22);
    background: rgba(255, 255, 255, 0.62);
    box-shadow: 0 rem(6) rem(18) rgba(40, 55, 32, 0.08);
    backdrop-filter: blur(5px);
}

.studio_toolbar_actions {
    display: flex;
    align-items: center;
    flex: 0 1 auto;
    gap: rem(5);
    min-width: 0;
    overflow-x: auto;

    &::-webkit-scrollbar {
        display: none;
    }
}

.studio_preset_btn {
    .van-icon {
        margin-left: rem(4);
        font-size: rem(18);
    }
}

.studio_preset_dropdown {
    position: absolute;
    left: rem(6);
    top: rem(46);
    z-index: 46;
    display: grid;
    grid-template-columns: repeat(2, rem(76));
    gap: rem(6);
    padding: rem(8);
    border: 1px solid rgba(218, 226, 207, 0.9);
    border-radius: rem(14);
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 rem(8) rem(22) rgba(40, 55, 32, 0.14);
    backdrop-filter: blur(5px);

    button {
        height: rem(36);
        border: 0;
        border-radius: rem(18);
        background: #f4f7ef;
        color: #56614f;
        font-size: rem(20);
        font-weight: bold;

        &.active {
            background: #6e9f21;
            color: #fff;
        }
    }
}

.studio_tool_btn {
    flex: 0 0 auto;
    height: rem(34);
    min-width: rem(54);
    padding: 0 rem(10);
    border: 1px solid rgba(218, 226, 207, 0.9);
    border-radius: rem(17);
    background: rgba(255, 255, 255, 0.9);
    color: #56614f;
    font-size: rem(19);
    font-weight: bold;
    white-space: nowrap;

    &.active {
        border-color: #9bc45a;
        background: #e8efd5;
        color: #5f8f18;
    }
}

.studio_clear_btn {
    color: #c86436;
}

.studio_upload_input {
    display: none;
}

.studio_float_panel {
    position: fixed;
    left: rem(18);
    right: rem(18);
    top: rem(218);
    z-index: 42;
    max-height: 44vh;
    padding: rem(18);
    overflow-y: auto;
    border: 1px solid rgba(220, 226, 211, 0.72);
    border-radius: rem(18);
    background: rgba(255, 255, 255, 0.82);
    box-shadow: 0 rem(10) rem(30) rgba(40, 55, 32, 0.14);
    backdrop-filter: blur(6px);
}

.studio_float_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: rem(14);
    color: #2f382e;
    font-size: rem(24);
    font-weight: bold;

    button {
        height: rem(42);
        padding: 0 rem(18);
        border: 0;
        border-radius: rem(21);
        background: #e8efd5;
        color: #5f8f18;
        font-size: rem(22);
        font-weight: bold;
    }
}

.studio_library_grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: rem(12);
}

.studio_library_item {
    min-width: 0;
    padding: 0;
    border: 1px solid rgba(218, 226, 207, 0.9);
    border-radius: rem(12);
    background: rgba(255, 255, 255, 0.9);
    overflow: hidden;
    color: #4f5a4a;
    font-size: rem(20);

    span {
        display: block;
        height: rem(112);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
    }

    em {
        display: block;
        padding: rem(8) rem(6);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-style: normal;
    }

    &.active {
        border-color: #8bbf4f;
        box-shadow: 0 0 0 rem(2) rgba(139, 191, 79, 0.2);
    }
}

.studio_empty {
    padding: rem(20) 0;
    color: #77806f;
    font-size: rem(23);
    text-align: center;
}

.studio_adjust_row {
    display: grid;
    grid-template-columns: rem(64) 1fr rem(70);
    align-items: center;
    gap: rem(14);
    min-height: rem(56);
    color: #4f5a4a;
    font-size: rem(22);

    + .studio_adjust_row {
        margin-top: rem(8);
    }

    em {
        color: #6e9f21;
        font-style: normal;
        font-weight: bold;
        text-align: right;
    }
}

.riso_bar_actived {
    color: #6e9f21;
    background: #e8efd5;

    > div {
        background: #6e9f21;
        animation: colorChange 1.5s infinite;
    }
}

.design_bar {
    position: fixed;
    right: rem(18);
    top: rem(100);
    height: rem(53);
    width: rem(160);
    border-radius: rem(27);

    color: #6e9f21;
    background: #e8efd5;

    > div {
        background: #6e9f21;
        animation: colorChange 1.5s infinite;
    }
}
@keyframes colorChange {
    0% {
        background: #6e9f21;
    }

    50% {
        background: #ff8f2f;
    }

    100% {
        background: #6e9f21;
    }
}

.input_pop {
    padding: rem(20) 0;
}

.req_poup {
    padding: rem(20) rem(29) rem(59) rem(29);

    .label {
        font-size: rem(28);
        padding: rem(22) 0 rem(11) 0;
        font-weight: bold;
    }

    .text {
        font-size: rem(26);
        color: #666;
        line-height: rem(40);
    }

    .link {
        font-size: rem(26);
        color: #007cd9;

        i {
            margin-right: rem(4);
        }

        padding-bottom: rem(29);
        border-bottom: 1px solid #eee;
    }
}

.score_pop {
    max-height: 72vh;
    overflow-y: auto;
    padding: rem(28) rem(28) rem(36);
    background: #f7f8f5;
}

.score_head {
    padding: rem(24);
    background: #fff;
    border-radius: rem(8);
    border: 1px solid #e6ebdd;

    > div {
        display: flex;
        justify-content: space-between;
        align-items: baseline;

        span {
            color: #2e3531;
            font-size: rem(32);
            font-weight: bold;
        }

        strong {
            color: #6e9f21;
            font-size: rem(64);
            line-height: 1;
        }
    }

    p {
        margin: rem(16) 0 0;
        color: #666;
        font-size: rem(25);
        line-height: rem(38);
    }
}

.score_metrics {
    margin-top: rem(20);
}

.score_metric {
    padding: rem(22);
    background: #fff;
    border-radius: rem(8);
    border: 1px solid #e8e8e8;

    + .score_metric {
        margin-top: rem(14);
    }

    .metric_title {
        display: flex;
        justify-content: space-between;
        color: #2e3531;
        font-size: rem(26);
        font-weight: bold;

        strong {
            color: #ff8f2f;
        }
    }

    .metric_bar {
        height: rem(10);
        margin-top: rem(14);
        border-radius: rem(5);
        background: #edf0ea;
        overflow: hidden;

        > div {
            height: 100%;
            background: linear-gradient(90deg, #8bbf4f, #ffb45e);
        }
    }

    p {
        margin: rem(12) 0 0;
        color: #666;
        font-size: rem(23);
        line-height: rem(34);
    }
}

.score_suggestions {
    margin-top: rem(20);
    padding: rem(24);
    background: #fff;
    border-radius: rem(8);
    border: 1px solid #e6ebdd;
}

.suggestion_title {
    color: #2e3531;
    font-size: rem(28);
    font-weight: bold;
    margin-bottom: rem(14);
}

.suggestion_item {
    color: #555;
    font-size: rem(24);
    line-height: rem(36);

    + .suggestion_item {
        margin-top: rem(12);
    }
}

.bottom_controller {
    position: fixed;
    bottom: 0;
    width: 100vw;
    z-index: 80;
    pointer-events: none;

    > * {
        pointer-events: auto;
    }

    .act_detail {
        min-height: rem(96);
        padding: rem(8) 0;

        > div {
            width: 100vw;
        }
    }

    .act_layout {
        padding: 0 rem(40);
    }

    .container_act_panel .act_detail {
        min-height: rem(78);
        padding: rem(6) 0;
    }

    .container_act_panel .act_layout {
        padding: 0 rem(18);
    }
}

.act_panel {
    position: relative;
    margin: 0 rem(14) rem(8);
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid rgba(217, 226, 202, 0.62);
    border-radius: rem(16);
    box-shadow: 0 rem(8) rem(24) rgba(40, 55, 32, 0.12);
    overflow: hidden;
    z-index: 2;
}

.container_act_panel {
    background: rgba(255, 255, 255, 0.56);
    backdrop-filter: blur(4px);
}

.bottom_tool_strip {
    position: relative;
    display: flex;
    align-items: center;
    min-height: rem(132);
    padding: rem(12) rem(18) calc(env(safe-area-inset-bottom) + #{rem(14)});
    background: rgba(255, 255, 255, 0.96);
    border-top: 1px solid rgba(220, 226, 211, 0.9);
    box-shadow: 0 rem(-8) rem(28) rgba(40, 55, 32, 0.1);
    box-sizing: border-box;
    overflow: hidden;
    z-index: 3;
}

.bottom_tools_grid {
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: repeat(2, rem(50));
    grid-auto-columns: max-content;
    grid-row-gap: rem(8);
    grid-column-gap: rem(10);
    flex: 1;
    min-width: 0;
    margin-left: rem(14);
    padding: rem(2) rem(2) rem(4);
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
        display: none;
    }
}

.bottom_tool {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    height: rem(50);
    min-width: rem(72);
    padding: 0 rem(16);
    border: 1px solid #edf0e4;
    border-radius: rem(25);
    background: #fff;
    color: #596156;
    font-size: rem(23);
    line-height: 1;
    box-sizing: border-box;

    .van-icon {
        margin-right: rem(6);
        font-size: rem(28);
    }

}

.bottom_tool_active {
    background: #e8efd5;
    color: #5f8f18;
    border-color: #b7d47b;
    font-weight: bold;
}

.bottom_tool_disabled {
    background: #f1f2ef;
    color: #b2b8ad;
    border-color: #e0e3dc;
    box-shadow: none;
}

.material_catalog_tool {
    flex-direction: column;
    width: rem(156);
    height: rem(108);
    min-width: rem(156);
    padding: 0 rem(14);
    border-radius: rem(22);
    background: #6e9f21;
    border-color: #6e9f21;
    color: #fff;
    font-size: rem(24);
    font-weight: bold;
    box-shadow: 0 rem(6) rem(16) rgba(110, 159, 33, 0.28);

    .van-icon {
        margin-right: 0;
        margin-bottom: rem(8);
        font-size: rem(34);
    }
}

.bottom_tool.hide {
    display: none;
}

.work_bar {
    background: #fff;
    padding: rem(20) 0;

    > div {
        flex: 1;
        height: rem(50);
        color: #666;
        font-size: rem(28);

        i {
            margin-right: rem(17);
            color: #2e3531;
            font-size: rem(30);
        }

        + div {
            border-left: 1px solid #dcdcdc;
        }
    }
}

.count_down {
    position: fixed;
    font-size: rem(26);
    top: rem(40);
    width: rem(400);
    text-align: center;
    left: rem(200);
}

#ls_vedio {
    width: 100%;
    height: 50vh;
}
</style>
